import { brandColors, productColors } from '@givebutter/util';
import { FocusVisible } from 'components/util';
import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
    *:not(.mce-mergetag) {
        font-family: ${props => props.theme.typography.font};
    }

    * {
        font-variant-ligatures: none;
        font-variant-numeric: proportional-nums !important;
        font-family: ${props => props.theme.typography.font};
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;
    }

    .no-scroll {
        overflow: hidden;
    }

    body {
        color: ${productColors.gray[900]};
        margin: 0 auto;
        padding: 0;
        font-weight: ${props => props.theme.typography.body.weight};
        background-color: ${productColors.gray[50]};
        letter-spacing: 0;
    }

    [role='dialog'] {
        font-size: 16px;
    }

    a {
        text-decoration: none;
        font-family: inherit;
        -webkit-transition: ${props => props.theme.utility.transition};
        -o-transition: ${props => props.theme.utility.transition};
        transition: ${props => props.theme.utility.transition};
        font-weight: 500;
        cursor: pointer !important;
        position: relative;
        color: ${brandColors.cobalt.primary};

        &:hover {
            color: ${brandColors.cobalt.dark};
        }
    }

    strong, th {
        font-weight: 500 !important;
    }

    .clearfix {
        *zoom: 1;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        line-height: 0;
        content: '';
    }

    .clearfix:after {
        clear: both;
    }

    // safari ugly buttons fix
    button,
    html [type='button'],
    [type='reset'],
    [type='submit'],
    &:focus {
        -webkit-appearance: none !important;
        outline: transparent none 0;
    }

    // we use :where to make this less specific than class selectors
    :where(a),
    :where(td),
    :where(th),
    :where(th > *),
    :where(button),
    :where(*[type='button']),
    :where(*[role='button'])
    {
        position: relative;

        &:focus-visible {
            ${FocusVisible};
        }
    }

    // tinymce
    .tox-tinymce-aux,
    .tox-dialog,
    .tox-dialog-wrap,
    .tox-dialog__popups,
    .tox-menu,
    .tox-collection,
    .tox-collection--list,
    .tox-selected-menu {
        z-index: ${props => props.theme.zIndex.Outermost} !important;
        pointer-events: all;
    }

    // helps to fit AI plugin dialog in letters editor
    div[data-state=open] .tox-dialog.tox-dialog-inline {
        max-width: 600px;
    }

    .tox-toolbar__overflow {
        max-width: 500px !important;
    }

    .mce-content-body[data-mce-placeholder]:not(.mce-visualblocks)::before {
        width: 250px;
        color: #d1d5db !important;

        @media only screen and (max-width: 768px) {
            width: 150px;
        }
    }

    .mce-content-body {
        width: 100%;
    }

    .tox-edit-area::before {
        border: 0 !important;
    }

    // canva
    div:has(iframe[src*="canva"]) {
        z-index: ${props => props.theme.zIndex.Outermost} !important;
    }

    // intercom chat
    div#intercom-container:has(.intercom-messenger-frame) {
        z-index: ${props => props.theme.zIndex.Outermost};
        position: relative;
    }

    // react-flow (workflows)
    .react-flow__node {
        transition: .2s opacity ease-in;
    }
    .selected .react-flow__edge-path,
    .react-flow__edge.selected .react-flow__edge-path,
    .react-flow__edge-path {
        stroke: rgb(209 213 219);
    }

    // FLATFILE
    .flatfile_iframe-wrapper.flatfile_displayAsModal {
        width: 100% !important;
        height: 100% !important;
        z-index: 2147483647 !important;
    }

    .flatfile-no-modal-container .flatfile_iframe-wrapper {
        height: auto;
        padding: 0;
    }

    .flatfile-close-button {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .flatfile-no-modal-container .flatfile-close-button {
        display: none;
    }
`;

export { GlobalStyle };
